import { AlertTriangle, Clock, Eye, XCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { DocumentFlags } from '@/types/document.types';

interface DocumentFlagIconsProps {
  flags?: DocumentFlags;
}

const FLAG_CONFIG = [
  {
    key: 'nameMismatch',
    icon: AlertTriangle,
    color: 'text-amber-600 bg-amber-50',
    labelKey: 'documents.flags.nameMismatch',
  },
  {
    key: 'expired',
    icon: XCircle,
    color: 'text-red-600 bg-red-50',
    labelKey: 'documents.flags.expired',
  },
  {
    key: 'expiringSoon',
    icon: Clock,
    color: 'text-orange-600 bg-orange-50',
    labelKey: 'documents.flags.expiringSoon',
  },
  {
    key: 'illegible',
    icon: Eye,
    color: 'text-purple-600 bg-purple-50',
    labelKey: 'documents.flags.illegible',
  },
] as const;

export function DocumentFlagIcons({ flags }: DocumentFlagIconsProps) {
  const { t } = useTranslation();

  if (!flags) return null;

  const activeFlags = FLAG_CONFIG.filter((cfg) => flags[cfg.key]);

  if (activeFlags.length === 0) return null;

  return (
    <div className='flex items-center gap-1'>
      {activeFlags.map((cfg) => {
        const Icon = cfg.icon;
        return (
          <span
            key={cfg.key}
            title={t(cfg.labelKey)}
            className={`inline-flex items-center justify-center rounded p-1 ${cfg.color}`}>
            <Icon className='h-3.5 w-3.5' />
          </span>
        );
      })}
    </div>
  );
}
